import { useCallback } from 'react'
import type { ActionHistoryEntry } from './useTrackActionHistory'
import type { VisitLifecycleState } from './useCurrentState'

type Input = {
  setCurrentState: StateSetter<VisitLifecycleState>
  setStateHistory: StateSetter<VisitLifecycleState[]>
  setActionHistory: StateSetter<ActionHistoryEntry[]>
}

export function useTransitionState({ setCurrentState, setStateHistory, setActionHistory }: Input) {
  // Helper function to transition to a new state
  return useCallback(
    (newState: VisitLifecycleState) => {
      setCurrentState((prevState) => {
        if (prevState !== newState) {
          setStateHistory((history) => [...history, newState])
          setActionHistory((actions) => [
            ...actions,
            {
              type: 'STATE_TRANSITION',
              from: prevState,
              to: newState,
              timestamp: Date.now(),
            },
          ])
          return newState
        }
        return prevState
      })
    },
    [setCurrentState, setStateHistory, setActionHistory],
  )
}
